import { IconSort as Icon } from '@components/icons';
import { Wrapper } from './SortButton.styles';

interface SortButtonProps {
  sort?: string;
}
export const SortButton = ({ sort }: SortButtonProps) => {
  return (
    <Wrapper sort={sort}>
      <Icon />
    </Wrapper>
  );
};
